
import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { getListaUsuariosByClienteId } from 'src/redux/slices/user';

// components
import { useSnackbar } from 'notistack';
import useAuth from 'src/hooks/useAuth';
import { setContato } from 'src/redux/slices/global';
import ModalVerContato from 'src/sections/@dashboard/cadastro/ModalVerContato';
import getActionCriarChatAndNovaMensagem from 'src/actions/chats/getActionCriarChatAndNovaMensagem';
import { validarNumeroWhatsapp } from 'src/utils/functions';
import getActionChatInfo from 'src/actions/chats/getActionChatInfo';
import { PATH_CHAT } from 'src/routes/paths';
import v2_actionListaContatosCliente from 'src/actions/v2/contatos/v2_actionListaContatosCliente';
import v2_actionPesquisarContatos from 'src/actions/v2/contatos/v2_actionPesquisarContatos';
import { getChatInfoByChatId, getMensagensWhatsapp, getMensagensWhatsappDb, setChatInfo } from 'src/redux/slices/chat';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import ModalUploadContatos from 'src/sections/@dashboard/cadastro/ModalUploadContatos';
import Iconify from 'src/components/Iconify';
import ModalGerenciarListas from 'src/sections/@dashboard/cadastro/ModalGerenciarListas';

//zui
import v2_actionExportarContatos from 'src/actions/v2/contatos/v2_actionExportarContatos';
import v2_actionVerificarNumero from 'src/actions/v2/cliente/v2_actionVerificarNumero';
// ----------------------------------------------------------------------

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "src/@/components/ui/dialog";

import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "src/@/components/ui/select"

import { Input } from 'src/@/components/ui/input';
import { Tooltip } from '@mui/material';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import v2_actionBuscarChatById from 'src/actions/v2/services/chats/v2_actionBuscarChatById';
import ModalConfimacao from 'src/components/modal/ModalConfimacao';
import v2_actionDeletarContato from 'src/actions/v2/contatos/v2_actionDeletarContato';
import v2_actionVincularContatosLista from 'src/actions/v2/contatos/v2_actionVincularContatosLista';
import v2_actionListarListas from 'src/actions/v2/contatos/v2_actionListarListas';
import { formataNumeroCelular } from 'src/utils/functions';
import { fDateTime } from 'src/utils/formatTime';
import { Checkbox } from 'src/@/components/ui/checkbox';
import useResponsive from 'src/hooks/useResponsive';
import { CONTATOS_DESIGN as D } from './Contatos.design';

// ----------------------------------------------------------------------

function applyFilter(tableData, filterName) {
    if (!filterName) return tableData;

    return tableData.filter((item) => {
        const searchTerm = filterName.toLowerCase();
        return (
            item.nome?.toLowerCase().includes(searchTerm) ||
            item.telefone?.includes(searchTerm) ||
            item.info?.email?.toLowerCase().includes(searchTerm) ||
            item.info?.cpf?.includes(searchTerm) ||
            item.info?.endereco?.cidade?.toLowerCase().includes(searchTerm)
        );
    });
}

const ModalConfirmChannel = ({
    open,
    contato,
    user,
    cliente,
    onOpenChange,
    canais,
    onSubmit,
    enqueueSnackbar,
    onClose,
    navigate,
    dispatch
}) => {
    const { t } = useTranslation('chat');
    const [selected, setSelected] = useState(null);
    const [loadingNovoChat, setLoadingNovoChat] = useState(false);

    function buscarMessagesAndInfo(chat) {
        // setChatInfo antes do fetch: getMensagensWhatsappDb decide o canal pelo
        // chatInfo do store — na ordem antiga lia o chat anterior (Instagram abria
        // como whatsapp&numero= no 1o clique).
        if (chat) {
            dispatch(setChatInfo(chat));
        } else {
            dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
        }
        if (cliente.config.chat_source_db) {
            dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
        } else {
            dispatch(getMensagensWhatsapp(chat.sessao, chat.numeroCliente));
        }
    }


    async function checkIsMyChat(id) {
        try {
            const response = await v2_actionBuscarChatById(id);
            if (response.status === 200) {
                if (response.data.direciona_usuarios.includes(user.id)) {
                    buscarMessagesAndInfo(response.data);
                    navigate(`${PATH_CHAT.chat.root}`);
                    return true;
                } else {
                    enqueueSnackbar(t('contacts.chatAlreadyWithAgent', 'Chat já está cadastrado com outro agente'), { variant: 'warning' });
                    return false;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    async function onCriarChat(row) {
        setLoadingNovoChat(true);


        try {
            let querys = `?is_contact=1&is_chat=1&is_whatsapp=1`;
            const checkNumber = await v2_actionVerificarNumero(selected?.cliente_id, validarNumeroWhatsapp(row.telefone), querys);

            if (checkNumber.status === 200) {
                if (checkNumber.data.data.isChatExist) {
                    checkIsMyChat(checkNumber.data.data.chatId);
                    setLoadingNovoChat(false);
                    return;
                } else if (!checkNumber.data.data.isWhatsapp) {
                    enqueueSnackbar(t('contacts.numberNotWhatsapp', 'Erro ao criar chat. Número não existe no whatsapp'), { variant: 'error' });
                    setLoadingNovoChat(false);
                    return;
                }
            }
            const response_chat_info = await getActionChatInfo(selected.cliente_id, validarNumeroWhatsapp(row.telefone));

            if (response_chat_info.data) {
                checkIsMyChat(checkNumber.data._id);
                setLoadingNovoChat(false);
            } else {

                try {
                    let data1 = {
                        nomeCliente: row.nome || '',
                        numeroCliente: validarNumeroWhatsapp(row.telefone),
                        statusRoom: "Atendendo",
                        usuarioId: user.id,
                        clienteId: selected.cliente_id
                    }
                    await getActionCriarChatAndNovaMensagem(data1)
                    await getActionChatInfo(selected.cliente_id, validarNumeroWhatsapp(row.telefone));
                    setLoadingNovoChat(false);
                    navigate(`${PATH_CHAT.chat.root}`);
                } catch (error) {
                    console.log(error)
                    setLoadingNovoChat(false)
                }

            }
        } catch (error) {
            console.log(error)
            setLoadingNovoChat(false)
        }

    }

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px]" style={{ fontFamily: D.fontStack }}>
                <DialogHeader>
                    <DialogTitle className={D.dialogTitle}>{t('contacts.createChat.title', 'Criar chat')}</DialogTitle>
                    <DialogDescription className={D.dialogDesc}>
                        {t('contacts.createChat.selectChannelDescription', 'Selecione o canal que deseja utilizar para criar o chat')}
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-5 py-2 w-full">
                    <div>
                        <label className={D.label}>{t('scheduling.selectChannel', 'Selecione o canal')}</label>
                        <Select onValueChange={value => setSelected(value)} value={selected}>
                            <SelectTrigger className={D.select}>
                                <SelectValue placeholder={t('scheduling.selectChannel', 'Selecione o canal')} />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectGroup>
                                    {canais && canais.map((item, index) => (
                                        <SelectItem key={item._id || index} value={item}>
                                            {item.nome}
                                        </SelectItem>
                                    ))}
                                </SelectGroup>
                            </SelectContent>
                        </Select>
                    </div>
                </div>
                <DialogFooter className={D.dialogFooter}>
                    <button type="button" className={D.ghostButton} onClick={onClose}>
                        {t('buttons.cancel', { ns: 'common', defaultValue: 'Cancelar' })}
                    </button>
                    <ButtonLoading onClick={() => onCriarChat(contato)} loading={loadingNovoChat} className={D.primaryButton}>
                        {t('contacts.createChat.title', 'Criar chat')}
                    </ButtonLoading>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}



// Colunas ocultas da tabela de contatos (basta remover a chave para exibir de novo)
const HIDDEN_COLUMNS = ['listas'];

export default function Contatos() {
    const { t } = useTranslation(['chat', 'common']);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { user, cliente } = useAuth();
    // Modal "Novo Contato" vive no AuthGuard (setContato). Ao fechar apos criar,
    // o Redux e atualizado mas esta pagina usa state local — precisa refetch.
    const contatoModalOpen = useSelector((state) => state.global.contato?.openModal);
    const wasContatoModalOpen = useRef(false);
    const isMobile = useResponsive('down', 'md');
    const isCompact = useResponsive('down', 'lg');

    const TABLE_COLUMNS = [
        { key: 'nome', label: t('labels.name', { ns: 'common', defaultValue: 'Nome' }), minW: '160px', sticky: true, stickyLeft: '36px' },
        { key: 'listas', label: t('contacts.table.lists', 'Listas'), minW: '140px', hiddenOnMobile: true },
        { key: 'telefone', label: t('labels.phone', { ns: 'common', defaultValue: 'Telefone' }), minW: '140px' },
        { key: 'cidade', label: t('contacts.table.city', 'Cidade'), minW: '120px', hiddenOnMobile: true, hiddenOnCompact: true },
        { key: 'data_criacao', label: t('contacts.table.createdAt', 'Criação'), minW: '150px', hiddenOnMobile: true, hiddenOnCompact: true },
        { key: 'custom_fields', label: t('contacts.table.customFields', 'Campos'), minW: '180px', hiddenOnMobile: true, hiddenOnCompact: true },
        { key: 'actions', label: t('contacts.table.actions', 'Ações'), minW: '120px' },
    ];
    const visibleColumns = TABLE_COLUMNS.filter(
        col => !HIDDEN_COLUMNS.includes(col.key) && !(isMobile && col.hiddenOnMobile) && !(isCompact && col.hiddenOnCompact)
    );
    const showCol = (key) => visibleColumns.some(col => col.key === key);
    const [contatos, setContatos] = useState([]);
    const [loadingContatos, setLoadingContatos] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [openModalVerContato, setStateModalVerContato] = useState(false);
    const [pesquisa, setPesquisa] = useState('');
    const [filterName, setFilterName] = useState('');
    const [contatoData, setContatoData] = useState(null);
    const [loadingNovoChat, setLoadingNovoChat] = useState(false);
    const tableData = contatos
    const [listaClientesCanais, setListaClientesCanais] = useState([]);

    const [canais, setCanais] = useState([]);
    const [selectedCanal, setSelectedCanal] = useState(null);

    const [openModalCriarChat, setOpenModalCriarChat] = useState(false);
    const [contatoChat, setContatoChat] = useState(null);

    const filteredUsers = applyFilter(tableData, filterName);
    const [openModalUpload, setOpenModalUpload] = useState(false);

    const [modalConfimacao, setModalConfirmacao] = useState(false);
    const [contatoId, setContatoId] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openModalListas, setOpenModalListas] = useState(false);

    const [selectedContatos, setSelectedContatos] = useState([]);
    const [listas, setListas] = useState([]);
    const [openModalVincularLista, setOpenModalVincularLista] = useState(false);
    const [selectedListaId, setSelectedListaId] = useState(null);
    const [loadingVincular, setLoadingVincular] = useState(false);

    const currentPageRows = filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    const allCurrentPageSelected = currentPageRows.length > 0 && currentPageRows.every(row => selectedContatos.includes(row._id));

    function toggleSelectContato(id) {
        setSelectedContatos(prev => prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]);
    }

    function toggleSelectAll() {
        if (allCurrentPageSelected) {
            setSelectedContatos(prev => prev.filter(id => !currentPageRows.some(row => row._id === id)));
        } else {
            const newIds = currentPageRows.map(row => row._id).filter(id => !selectedContatos.includes(id));
            setSelectedContatos(prev => [...prev, ...newIds]);
        }
    }

    async function handleVincularLista() {
        if (!selectedListaId || selectedContatos.length === 0) return;
        try {
            setLoadingVincular(true);
            await v2_actionVincularContatosLista(selectedContatos, selectedListaId);
            enqueueSnackbar(t('contacts.linkedSuccess', '{{count}} contato(s) vinculado(s) com sucesso', { count: selectedContatos.length }), { variant: 'success' });
            setSelectedContatos([]);
            setOpenModalVincularLista(false);
            setSelectedListaId(null);
            await refreshContatosList();
        } catch (error) {
            console.log(error);
            enqueueSnackbar(t('contacts.linkError', 'Erro ao vincular contatos'), { variant: 'error' });
        } finally {
            setLoadingVincular(false);
        }
    }

    function buscarMessagesAndInfo(chat) {
        // setChatInfo antes do fetch: getMensagensWhatsappDb decide o canal pelo
        // chatInfo do store — na ordem antiga lia o chat anterior (Instagram abria
        // como whatsapp&numero= no 1o clique).
        if (chat) {
            dispatch(setChatInfo(chat));
        } else {
            dispatch(getChatInfoByChatId(chat._id, chat.funil_id, user.id, true));
        }
        if (cliente.config.chat_source_db) {
            dispatch(getMensagensWhatsappDb(chat.sessao, chat.numeroCliente));
        } else {
            dispatch(getMensagensWhatsapp(chat.sessao, chat.numeroCliente));
        }
    }

    async function checkIsMyChat(id) {
        try {
            const response = await v2_actionBuscarChatById(id);

            if (response.status === 200) {
                if (response.data.direciona_usuarios.includes(user.id)) {
                    buscarMessagesAndInfo(response.data);
                    navigate(`${PATH_CHAT.chat.root}`);
                    return true;
                } else {
                    enqueueSnackbar(t('contacts.chatAlreadyWithAgent', 'Chat já está cadastrado com outro agente'), { variant: 'warning' });
                    return false;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    async function handleCriarChat(row) {
        setLoadingNovoChat(true);
        setContatoChat(row)
        // verificar se é multisession
        if (cliente?.multiSession === 1) {
            setOpenModalCriarChat(true);
            setLoadingNovoChat(false)
            return;
        }

        let querys = `?is_contact=1&is_chat=1&is_whatsapp=1`;
        const checkNumber = await v2_actionVerificarNumero(cliente._id, validarNumeroWhatsapp(row?.telefone), querys);

        if (checkNumber.status === 200) {
            if (checkNumber.data.data.isChatExist) {
                checkIsMyChat(checkNumber.data.data.chatId);
                setLoadingNovoChat(false)
                return;
            } else if (!checkNumber.data.data.isWhatsapp) {
                enqueueSnackbar(t('contacts.numberNotWhatsapp', 'Erro ao criar chat. Número não existe no whatsapp'), { variant: 'error' });
                setLoadingNovoChat(false)
                return;
            }
        }

        try {
            const response_chat_info = await getActionChatInfo(cliente._id, validarNumeroWhatsapp(row.telefone));
            if (response_chat_info.data) {
                buscarMessagesAndInfo(response_chat_info.data.data);
                setLoadingNovoChat(false);
            } else {

                try {
                    let data1 = {
                        nomeCliente: row.nome || '',
                        numeroCliente: validarNumeroWhatsapp(row.telefone),
                        statusRoom: "Atendendo",
                        usuarioId: user.id,
                        clienteId: cliente._id
                    }
                    await getActionCriarChatAndNovaMensagem(data1)
                    await getActionChatInfo(cliente._id, validarNumeroWhatsapp(row.telefone));
                    setLoadingNovoChat(false);
                    navigate(`${PATH_CHAT.chat.root}`);
                } catch (error) {
                    console.log(error)
                    setLoadingNovoChat(false)
                }

            }
        } catch (error) {
            enqueueSnackbar(t('newChat.errors.createFailed', 'Erro ao criar chat'), { variant: 'error' });

            console.log(error)
            setLoadingNovoChat(false)
        }
    }


    async function buscarListaClientesCanais() {
        try {
            const response_clientes_canais = await actionListaClientesCanais(cliente._id)
            setListaClientesCanais(response_clientes_canais.data.data);
        } catch (err) {
            console.log(err)
        }
    }

    async function handleDeleteContact() {
        try {
            setLoadingDelete(true);
            const response = await v2_actionDeletarContato(contatoId);
            if (response.status === 200) {
                enqueueSnackbar(t('contacts.deleteSuccess', 'Contato deletado com sucesso'), { variant: 'success' });
                const result = await v2_actionListaContatosCliente(cliente._id);
                setContatos(result.data.data);
                setContatoId(null);
                setLoadingDelete(false);
            }
        } catch (error) {
            console.log(error);
            setContatoId(null);
            setLoadingDelete(false);
            enqueueSnackbar(t('contacts.deleteError', 'Erro ao deletar contato'), { variant: 'error' });
        }
    }

    async function buscarCanais() {
        const response_clientes_canais = await actionListaClientesCanais(user.clienteId);
        // Só WhatsApp inicia conversa outbound; Instagram/Messenger/Webchat não.
        const canaisWhatsapp = (response_clientes_canais.data.data || []).filter(
            (c) => c.platform === 'whatsapp' || c.platform === 'whatsapp_business'
        );
        setCanais(canaisWhatsapp);
        setSelectedCanal(canaisWhatsapp[0]);
    }


    useEffect(() => {
        dispatch(getListaUsuariosByClienteId(user.clienteId));
        buscarCanais();
        buscarListaClientesCanais();
        v2_actionListarListas(cliente?._id).then(res => setListas(res.data?.data || [])).catch(console.log);

        async function carregarContatos() {
            if (cliente) {
                try {
                    setLoadingContatos(true);
                    const result = await v2_actionListaContatosCliente(cliente._id);
                    setContatos(result.data.data);
                } catch (error) {
                    console.log(error);
                } finally {
                    setLoadingContatos(false);
                }
            }
        }

        carregarContatos();
    }, []);

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    async function handlePesquisarContatos() {
        try {
            setLoadingContatos(true);
            if (pesquisa && pesquisa.trim() !== "") {
                const result = await v2_actionPesquisarContatos(cliente._id, pesquisa);
                setContatos(result.data.data);
                setFilterName(pesquisa);
            } else {
                const result = await v2_actionListaContatosCliente(cliente._id);
                setContatos(result.data.data);
                setFilterName('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContatos(false);
        }
    }


    const handleExportarContatos = async () => {
        try {
            const response = await v2_actionExportarContatos(cliente._id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `lais-contatos-leads.xlsx`);
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.log(error)
        }
    }
    async function refreshContatosList() {
        try {
            setLoadingContatos(true);
            if (pesquisa && pesquisa.trim() !== "") {
                const result = await v2_actionPesquisarContatos(cliente._id, pesquisa);
                setContatos(result.data.data);
                setFilterName(pesquisa);
            } else {
                const result = await v2_actionListaContatosCliente(cliente._id);
                setContatos(result.data.data);
                setFilterName('');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingContatos(false);
        }
    }

    // AuthGuard monta ModalNovoContato com callback vazio; ao fechar o modal
    // (sucesso ou cancelar) recarrega a lista local desta pagina.
    useEffect(() => {
        if (wasContatoModalOpen.current && !contatoModalOpen) {
            refreshContatosList();
        }
        wasContatoModalOpen.current = Boolean(contatoModalOpen);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contatoModalOpen]);

    return (
        <div className={D.root} style={{ fontFamily: D.fontStack }}>
            <ModalConfimacao
                open={modalConfimacao}
                onClose={() => {
                    setModalConfirmacao(false);
                    setContatoId(null);
                }}
                onConfirm={async () => {
                    try {
                        await handleDeleteContact();
                        setModalConfirmacao(false);
                    } catch (error) {
                        console.log(error);
                        setModalConfirmacao(false);
                    }
                }}
                loadingFinalizar={loadingDelete}
                mensagem={t('contacts.deleteConfirm', 'Deseja mesmo excluir esse contato?')}
            />
            {
                contatoData && (
                    <ModalVerContato
                        open={openModalVerContato}
                        onClose={() => setStateModalVerContato(false)}
                        contatoData={contatoData}
                        cliente={cliente}
                        user={user}
                        listaClientesCanais={[]}
                        loading={false}
                        callBackRefreshList={() => {
                            setStateModalVerContato(false);
                            refreshContatosList();
                        }}
                    />
                )
            }
            <ModalUploadContatos
                cliente={cliente}
                open={openModalUpload}
                onClose={() => setOpenModalUpload(false)}
                callBackRefreshList={refreshContatosList}
            />
            <ModalGerenciarListas
                open={openModalListas}
                onClose={() => setOpenModalListas(false)}
                clienteId={cliente?._id}
            />
            <ModalConfirmChannel
                open={openModalCriarChat}
                onClose={() => {
                    setOpenModalCriarChat(false);
                    setContatoChat(null);
                }}
                contato={contatoChat}
                cliente={cliente}
                user={user}
                onOpenChange={(value) => setOpenModalCriarChat(value)}
                canais={canais}
                enqueueSnackbar={enqueueSnackbar}
                navigate={navigate}
                dispatch={dispatch}
            />

            <Dialog open={openModalVincularLista} onOpenChange={() => { setOpenModalVincularLista(false); setSelectedListaId(null); }}>
                <DialogContent className="sm:max-w-[425px]" style={{ fontFamily: D.fontStack }}>
                    <DialogHeader>
                        <DialogTitle className={D.dialogTitle}>{t('contacts.linkList.title', 'Vincular a uma lista')}</DialogTitle>
                        <DialogDescription className={D.dialogDesc}>
                            {t('contacts.linkList.description', 'Selecione a lista para vincular {{count}} contato(s)', { count: selectedContatos.length })}
                        </DialogDescription>
                    </DialogHeader>
                    <div className="grid gap-5 py-2 w-full">
                        <div>
                            <label className={D.label}>{t('contacts.linkList.selectPlaceholder', 'Selecione a lista')}</label>
                            <Select onValueChange={value => setSelectedListaId(value)} value={selectedListaId}>
                                <SelectTrigger className={D.select}>
                                    <SelectValue placeholder={t('contacts.linkList.selectPlaceholder', 'Selecione a lista')} />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                        {listas.map((lista) => (
                                            <SelectItem key={lista._id} value={lista._id}>
                                                {lista.nome}
                                            </SelectItem>
                                        ))}
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                    <DialogFooter className={D.dialogFooter}>
                        <button type="button" className={D.ghostButton} onClick={() => { setOpenModalVincularLista(false); setSelectedListaId(null); }}>
                            {t('buttons.cancel', { ns: 'common', defaultValue: 'Cancelar' })}
                        </button>
                        <ButtonLoading onClick={handleVincularLista} loading={loadingVincular} disabled={!selectedListaId} className={D.primaryButton}>
                            {t('contacts.linkList.confirm', 'Vincular')}
                        </ButtonLoading>
                    </DialogFooter>
                </DialogContent>
            </Dialog>

            <div className={D.stickyHeader}>
                <div className={D.container}>
                    <div className={D.headerRow}>
                        <h1 className={D.title}>{t('contacts.pageTitle', 'Contatos')}</h1>

                        <div className={D.searchRow}>
                            <div className={D.searchField}>
                                <Input
                                    className={D.searchInput}
                                    placeholder={t('contacts.searchPlaceholder', 'Pesquisar por nome, telefone...')}
                                    value={pesquisa}
                                    onChange={(e) => setPesquisa(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') handlePesquisarContatos();
                                    }}
                                />
                                <button
                                    type="button"
                                    onClick={handlePesquisarContatos}
                                    className={D.searchIcon}
                                    aria-label={t('buttons.search', { ns: 'common', defaultValue: 'Buscar' })}
                                >
                                    <Iconify icon="eva:search-outline" width={18} />
                                </button>
                            </div>
                        </div>

                        <div className={D.topbarActions}>
                            <Tooltip title={t('contacts.listsTooltip', 'Listas permitem agrupar contatos por categorias (ex: leads, clientes VIP, campanha X) para organizar e segmentar seus envios')} placement="bottom">
                                <button type="button" onClick={() => setOpenModalListas(true)} className={D.ghostButton}>
                                    {t('contacts.listsButton', 'Listas')}
                                </button>
                            </Tooltip>
                            <button type="button" onClick={() => setOpenModalUpload(true)} className={D.ghostButton}>
                                {t('buttons.import', { ns: 'common', defaultValue: 'Importar' })}
                            </button>
                            <button type="button" onClick={handleExportarContatos} className={D.ghostButton}>
                                {t('buttons.export', { ns: 'common', defaultValue: 'Exportar' })}
                            </button>
                            <button
                                type="button"
                                onClick={() => dispatch(setContato({ loading: false, openModal: true }))}
                                className={D.primaryButton}
                            >
                                {t('newContact.title', 'Novo Contato')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className={D.body}>
                {selectedContatos.length > 0 && (
                    <div className={D.selectionBar}>
                        <div className="flex items-center gap-3 min-w-0">
                            <div className={D.selectionCount}>{selectedContatos.length}</div>
                            <span className={D.selectionLabel}>
                                {t('contacts.selectedLabel', 'contato(s) selecionado(s)')}
                            </span>
                        </div>
                        <div className="flex items-center gap-2 flex-shrink-0">
                            <button type="button" onClick={() => setOpenModalVincularLista(true)} className={D.primaryButton}>
                                {t('contacts.linkToList', 'Vincular a lista')}
                            </button>
                            <button type="button" onClick={() => setSelectedContatos([])} className={D.ghostButton}>
                                {t('messageList.clearSelection', 'Limpar seleção')}
                            </button>
                        </div>
                    </div>
                )}

                <div className={D.card}>
                    {loadingContatos ? (
                        <div className="flex items-center justify-center py-20 flex-1">
                            <Iconify icon="mdi:loading" className="w-8 h-8 text-[#6d28d9] animate-spin" />
                        </div>
                    ) : filteredUsers.length === 0 ? (
                        <div className={D.emptyState}>
                            <div className={D.emptyIcon}>
                                <Iconify icon="eva:people-outline" width={28} />
                            </div>
                            <p className={D.emptyTitle}>{t('contactSearch.noResults', 'Nenhum contato encontrado')}</p>
                            <p className={D.emptyDesc}>{t('contacts.empty.subtitle', 'Tente outra pesquisa ou adicione um novo contato')}</p>
                        </div>
                    ) : (
                        <>
                            {isMobile ? (
                                <div className={D.tableWrapNoScrollX}>
                                    <div className={`${D.tableHeaderRow} flex items-center gap-3 px-4 py-2.5`}>
                                        <Checkbox
                                            checked={allCurrentPageSelected}
                                            onCheckedChange={toggleSelectAll}
                                            className="data-[state=checked]:bg-[#6d28d9] data-[state=checked]:border-[#6d28d9]"
                                        />
                                        <span className={D.tableHead}>
                                            {t('contacts.table.selectAll', 'Selecionar todos')}
                                        </span>
                                    </div>

                                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIdx) => (
                                        <div
                                            key={row._id || rowIdx}
                                            className="flex items-start gap-3 px-4 py-3 border-b border-[#f0f0f3] last:border-b-0 active:bg-[#fafafb] cursor-pointer"
                                            onClick={() => {
                                                setContatoData(row);
                                                setStateModalVerContato(true);
                                            }}
                                        >
                                            <div className="pt-0.5 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                                                <Checkbox
                                                    checked={selectedContatos.includes(row._id)}
                                                    onCheckedChange={() => toggleSelectContato(row._id)}
                                                    className="data-[state=checked]:bg-[#6d28d9] data-[state=checked]:border-[#6d28d9]"
                                                />
                                            </div>

                                            <div className="flex-1 min-w-0">
                                                <p className={`${D.tableCell} font-medium truncate`}>{row.nome || '—'}</p>
                                                <p className={`${D.tableCellMuted} mt-0.5 truncate`}>
                                                    {formataNumeroCelular(row.telefone) || '—'}
                                                </p>
                                                {!HIDDEN_COLUMNS.includes('listas') && row.contact_lists_id && row.contact_lists_id.length > 0 && (
                                                    <div className="flex flex-wrap gap-1 mt-1.5">
                                                        {row.contact_lists_id.slice(0, 2).map((lista, idx) => (
                                                            <span key={idx} className={`${D.chip} max-w-[120px] truncate`}>{lista.nome}</span>
                                                        ))}
                                                        {row.contact_lists_id.length > 2 && (
                                                            <span className="text-[12px] font-semibold text-[#6d28d9]">
                                                                +{row.contact_lists_id.length - 2}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="flex items-center gap-1.5 flex-shrink-0" onClick={(e) => e.stopPropagation()}>
                                                <button
                                                    type="button"
                                                    disabled={loadingNovoChat}
                                                    onClick={() => handleCriarChat(row)}
                                                    className={D.iconButtonOk}
                                                    aria-label={t('contacts.createChat.title', 'Criar chat')}
                                                >
                                                    <Iconify icon="ic:baseline-whatsapp" width={14} />
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => {
                                                        setContatoId(row._id);
                                                        setModalConfirmacao(true);
                                                    }}
                                                    className={D.iconButtonDanger}
                                                    aria-label={t('buttons.delete', { ns: 'common', defaultValue: 'Excluir' })}
                                                >
                                                    <Iconify icon="eva:trash-2-outline" width={14} />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                            <div className={D.tableWrap}>
                                <table className="w-full text-left border-collapse">
                                    <thead>
                                        <tr className={D.tableHeaderRow}>
                                            <th className="sticky left-0 z-10 bg-[#fafafb] px-3 py-3 border-r border-[#f0f0f3] min-w-[44px] w-[44px]">
                                                <Checkbox
                                                    checked={allCurrentPageSelected}
                                                    onCheckedChange={toggleSelectAll}
                                                    className="data-[state=checked]:bg-[#6d28d9] data-[state=checked]:border-[#6d28d9]"
                                                />
                                            </th>
                                            {visibleColumns.map(col => (
                                                <th
                                                    key={col.key}
                                                    className={`${D.tableHead} px-3.5 py-3 border-r border-[#f0f0f3] last:border-r-0 ${col.sticky ? 'sticky z-10 bg-[#fafafb]' : ''}`}
                                                    style={{ minWidth: col.minW, ...(col.sticky ? { left: col.stickyLeft } : {}) }}
                                                >
                                                    {col.key === 'listas' ? (
                                                        <span className="inline-flex items-center gap-1">
                                                            {col.label}
                                                            <Tooltip title={t('contacts.table.listsTooltip', 'Listas são grupos que organizam seus contatos por segmento, facilitando envios em massa e campanhas direcionadas')} placement="top">
                                                                <span className="cursor-help text-[#a1a1aa] hover:text-[#6d28d9] transition-colors">
                                                                    <Iconify icon="eva:info-outline" width={13} />
                                                                </span>
                                                            </Tooltip>
                                                        </span>
                                                    ) : col.label}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, rowIdx) => (
                                            <tr
                                                key={row._id || rowIdx}
                                                className={D.tableRow}
                                                onClick={() => {
                                                    setContatoData(row);
                                                    setStateModalVerContato(true);
                                                }}
                                            >
                                                <td className="sticky left-0 z-10 bg-white px-3 py-2.5 border-r border-[#f0f0f3]" onClick={(e) => e.stopPropagation()}>
                                                    <Checkbox
                                                        checked={selectedContatos.includes(row._id)}
                                                        onCheckedChange={() => toggleSelectContato(row._id)}
                                                        className="data-[state=checked]:bg-[#6d28d9] data-[state=checked]:border-[#6d28d9]"
                                                    />
                                                </td>

                                                <td className="sticky left-[36px] z-10 bg-white px-3.5 py-2.5 border-r border-[#f0f0f3]">
                                                    <p className={`${D.tableCell} font-medium truncate`}>{row.nome || '—'}</p>
                                                </td>

                                                {showCol('listas') && <td className="px-3.5 py-2.5 border-r border-[#f0f0f3]">
                                                    <div className="flex flex-wrap gap-1">
                                                        {row.contact_lists_id && row.contact_lists_id.length > 0 ? (
                                                            row.contact_lists_id.map((lista, idx) => (
                                                                <span key={idx} className={D.chip}>{lista.nome}</span>
                                                            ))
                                                        ) : (
                                                            <span className="text-[#a1a1aa] text-[13px]">—</span>
                                                        )}
                                                    </div>
                                                </td>}

                                                <td className={`${D.tableCellMuted} px-3.5 py-2.5 border-r border-[#f0f0f3] whitespace-nowrap`}>
                                                    {formataNumeroCelular(row.telefone) || '—'}
                                                </td>

                                                {showCol('cidade') && <td className={`${D.tableCellMuted} px-3.5 py-2.5 border-r border-[#f0f0f3]`}>
                                                    {row.info?.endereco?.cidade || '—'}
                                                </td>}

                                                {showCol('data_criacao') && <td className={`${D.tableCellMuted} px-3.5 py-2.5 border-r border-[#f0f0f3] whitespace-nowrap`}>
                                                    {fDateTime(row.data_criacao) || '—'}
                                                </td>}

                                                {showCol('custom_fields') && <td className="px-3.5 py-2.5 border-r border-[#f0f0f3] max-w-[200px]">
                                                    {row.custom_fields && row.custom_fields.length > 0 ? (
                                                        <div className="flex flex-wrap gap-1">
                                                            {row.custom_fields.slice(0, 2).map((field, idx) => (
                                                                <span key={idx} className="text-[12px] truncate">
                                                                    <span className="font-semibold text-[#71717a]">{field.nome}:</span>
                                                                    <span className="ml-0.5 text-[#18181b]">{field.valor}</span>
                                                                </span>
                                                            ))}
                                                            {row.custom_fields.length > 2 && (
                                                                <span className="text-[12px] font-semibold text-[#6d28d9]">+{row.custom_fields.length - 2}</span>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <span className="text-[#a1a1aa] text-[13px]">—</span>
                                                    )}
                                                </td>}

                                                <td className="px-3.5 py-2.5" onClick={(e) => e.stopPropagation()}>
                                                    <div className="flex items-center gap-1.5">
                                                        <Tooltip title={t('contacts.actions.view', 'Ver contato')} placement="top">
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setContatoData(row);
                                                                    setStateModalVerContato(true);
                                                                }}
                                                                className={D.iconButton}
                                                            >
                                                                <Iconify icon="eva:eye-outline" width={14} />
                                                            </button>
                                                        </Tooltip>
                                                        <Tooltip title={t('contacts.createChat.title', 'Criar chat')} placement="top">
                                                            <button
                                                                type="button"
                                                                disabled={loadingNovoChat}
                                                                onClick={() => handleCriarChat(row)}
                                                                className={D.iconButtonOk}
                                                            >
                                                                <Iconify icon="ic:baseline-whatsapp" width={14} />
                                                            </button>
                                                        </Tooltip>
                                                        <Tooltip title={t('buttons.delete', { ns: 'common', defaultValue: 'Excluir' })} placement="top">
                                                            <button
                                                                type="button"
                                                                onClick={() => {
                                                                    setContatoId(row._id);
                                                                    setModalConfirmacao(true);
                                                                }}
                                                                className={D.iconButtonDanger}
                                                            >
                                                                <Iconify icon="eva:trash-2-outline" width={14} />
                                                            </button>
                                                        </Tooltip>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            )}

                            <div className={D.pagination}>
                                <div className="flex items-center gap-2">
                                    <span className={D.paginationText}>{t('pagination.rowsPerPage', { ns: 'common', defaultValue: 'Linhas por página' })}</span>
                                    <Select
                                        value={String(rowsPerPage)}
                                        onValueChange={(value) => {
                                            setRowsPerPage(Number(value));
                                            setPage(0);
                                        }}
                                    >
                                        <SelectTrigger className="h-8 w-[70px] text-[13px] border-[#d4d4d8] rounded-lg">
                                            <SelectValue placeholder={rowsPerPage} />
                                        </SelectTrigger>
                                        <SelectContent side="top">
                                            <SelectItem value="10">10</SelectItem>
                                            <SelectItem value="25">25</SelectItem>
                                            <SelectItem value="50">50</SelectItem>
                                        </SelectContent>
                                    </Select>
                                </div>

                                <div className="flex items-center gap-2">
                                    <span className={D.paginationText}>
                                        {filteredUsers.length > 0 ? page * rowsPerPage + 1 : 0}–{Math.min((page + 1) * rowsPerPage, filteredUsers.length)} {t('pagination.of', { ns: 'common', defaultValue: 'de' })} {filteredUsers.length}
                                    </span>
                                    <div className="flex items-center gap-1.5">
                                        <button
                                            type="button"
                                            className={D.iconButton}
                                            onClick={() => handleChangePage(Math.max(0, page - 1))}
                                            disabled={page === 0}
                                        >
                                            <Iconify icon="eva:chevron-left-outline" width={16} />
                                        </button>
                                        <span className={D.paginationText}>
                                            {page + 1} / {Math.max(1, Math.ceil(filteredUsers.length / rowsPerPage))}
                                        </span>
                                        <button
                                            type="button"
                                            className={D.iconButton}
                                            onClick={() => handleChangePage(page + 1)}
                                            disabled={(page + 1) * rowsPerPage >= filteredUsers.length}
                                        >
                                            <Iconify icon="eva:chevron-right-outline" width={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}